module.exports = __webpack_public_path__ + "static/media/sh.656a09eb.webp";